<template>
  <pt-lab-order-detail class="pt-lab-order-detail__page" :id="id" :value="value" ref="detail"></pt-lab-order-detail>
</template>

<script>
import PtLabOrderDetail from 'cps/lab-order/pt-lab-order-detail/withData'
export default {
  name: 'pt-lab-order-detail__view',
  components: {
    'pt-lab-order-detail': PtLabOrderDetail
  },
  props: {
    // 路由参数 - 产品id
    id: {
      type: String,
      required: true
    },
    // 路由参数 - 产品数据，父组件可以直接传入整个产品对象绑定到详情页，也可以不传。
    value: {
      type: Object,
      default: null
    }
  }
}
</script>
